var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-items-center my-3 stage-header"},[_c('GoBackBtn',{attrs:{"history-mode":""}}),_c('Title',{staticClass:"px-3",attrs:{"text":_vm.title}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }